import type { I18n } from '@lingui/core';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import ObservabilityMetadata from '@rover/rsdk/src/modules/ObservabilityMetadata';

import { Concept } from './concepts';

export type UseObservabilityMetadataConceptInfoArg = {
  concept?: Concept;
  uiComponentName?: string;
  uiName?: string;
};

export const useObservabilityMetadataConceptInfo = ({
  concept,
  uiComponentName,
  uiName,
}: UseObservabilityMetadataConceptInfoArg): void => {
  // we don't want to wrap this is useEffect because that can
  // delay execution and we want to set these values ASAP
  if (concept) {
    ObservabilityMetadata.set('concept', concept[0]);
    ObservabilityMetadata.set('team', concept[1]);
  }
  if (uiComponentName) {
    ObservabilityMetadata.set('uiComponentName', uiComponentName);
  }
  if (uiName) {
    ObservabilityMetadata.set('uiName', uiName);
  }
};

export type RSDKProviderProps = {
  children: React.ReactNode;
} & UseObservabilityMetadataConceptInfoArg & {
    locale: Locale;
    // Forwarded to `I18nProvider`. Optional so native (which activates its own global and
    // renders one locale) can take the global default; multi-locale hosts must pass one.
    i18n?: I18n;
  };
